import React, { createContext, useEffect, useState } from "react";

// Contexto a cargo de la lógica del estado de visualización de los paneles de navegación (header y sidebar),

export const MenuContext = createContext();

const MenuProvider = ({ data, children }) => {
  const sidebarItems = data;

  const [toggled, setToggled] = useState(false);
  const [scrollToTopIsVisible, setScrollToTopIsVisible] = useState(false);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const clickMenuOpen = () => setToggled(!toggled);

  // Al crear el layout menú se inserta este listener
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setScrollToTopIsVisible(true);
      } else {
        setScrollToTopIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);

    // Elimina la instancia del listener al destruirse el componente
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <MenuContext.Provider
      value={{ toggled, clickMenuOpen, sidebarItems, scrollToTopIsVisible, scrollToTop }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export default MenuProvider;
